import { createFileRoute, useRouter } from '@tanstack/react-router';
import { useCallback } from 'react';

import { OfferPage } from '~/components/offer/OfferPage';
import { useAnalytics } from '~/hooks/useAnalytics';
import { requireAuth } from '~/lib/route-guards';
import type { PublicLandingPage } from '~/types';

export const Route = createFileRoute('/$slug/offer')({
  beforeLoad: ({ context }: { context: Record<string, any> }) => {
    requireAuth(context.slug as string);
  },
  component: OfferRoute,
});

function OfferRoute() {
  const router = useRouter();
  const { slug, landingPage } = Route.useRouteContext() as {
    slug: string;
    landingPage: PublicLandingPage;
  };
  const { trackEvent } = useAnalytics({ slug, landingPageId: landingPage.id });

  const handleForwardClick = useCallback(() => {
    trackEvent('offer_click');
  }, [trackEvent]);

  const handlePlayAgain = useCallback(() => {
    if (landingPage.targetType === 'show') {
      router.navigate({ to: '/$slug/episodes', params: { slug } });
    } else {
      router.navigate({
        to: '/$slug/game/$episodeId',
        params: { slug, episodeId: landingPage.targetId },
      });
    }
  }, [router, slug, landingPage]);

  return (
    <OfferPage
      offerContent={landingPage.offerContent}
      branding={landingPage.branding}
      forwardUrl={landingPage.forwardUrl}
      title={landingPage.title}
      onForwardClick={handleForwardClick}
      onOfferView={() => trackEvent('offer_view')}
      targetType={landingPage.targetType}
      onPlayAgain={handlePlayAgain}
      showYakOffer={landingPage.showYakOffer}
    />
  );
}
